/**
 * Build the Authorization header for AmarLab API calls.
 *
 * The token in localStorage is JSON-encoded (i.e. stored with surrounding
 * quotes), which is why the rest of the app does `JSON.parse(...)` before
 * using it. Reading it raw produces `Token "abc123"` and the API answers 401.
 *
 * There IS a global axios interceptor that sets this header, but it is
 * registered inside AuthContext.fetchUserDetails() — so on a hard page reload
 * a request can fire before the interceptor exists. Setting the header
 * explicitly here makes a call work regardless of that timing.
 */
export const getAuthToken = () => {
  const raw = localStorage.getItem('token');
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'string' ? parsed : String(parsed);
  } catch (e) {
    // Older/plain values that were not JSON-encoded.
    return raw;
  }
};

export const getAuthHeader = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Token ${token}` } : null;
};

export default getAuthHeader;
